<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" class="form-container">
      <el-card class="form-card">
        <h1>We would like to hear from you!</h1>
        <el-form ref="feedbacknote">
          <el-form-item label="Message">
            <el-input class="tst-feedback-note" type="textarea" ref="feedbacknote" :rows="5" v-model="form.note" required></el-input>
          </el-form-item>

          <el-button class="tst-submit-feedback-button" type="primary" @click="SubmitForm()">Submit Feedback</el-button>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapState, mapActions } from "vuex";
import EventService from "@/services/EventService.js";
export default {
  data() {
    return {
      form: {
        note: ""
      },
      loadingFormSubmit: false
    };
  },

  methods: {
    SubmitForm() {

      this.loadingFormSubmit = true;

      //if (this.$refs.feedbacknote.validate()) {
      EventService.postFeedback(this.form, "true")
        .then(response => {
          if (response.status == 200) {
            this.$store.dispatch("addNotification", {
              type: "success",
              Message: "Thanks for your feedback!"
            });
            this.$router.push({ name: "DashboardAllProperties" });
          }
        })
        .catch(error => {
            console.log(error);
            this.loadingFormSubmit = false;
        });
      //}
    }
  }
};
</script>

<style>
</style>